import React from "react";
import { MTextField, ResponsiveFormContainer } from "@app/components";
import { MODES_OPTIONS } from "@app/types/generics.types";

interface CentelleoFormProps {
  mode: string;
}

const CentelleoForm = ({ mode }: CentelleoFormProps) => {
  const isView = mode === MODES_OPTIONS.VIEW;
  return (
    <ResponsiveFormContainer columns={5} mt={2}>
      <MTextField
        name="a"
        label="Término independiente"
        placeholder="Término independiente"
        type="number"
        validation={{ required: "Término independiente es requerido" }}
        fullWidth
        disabled={isView}
      />
      <MTextField
        name="x"
        label="X"
        placeholder="X"
        type="number"
        validation={{ required: "X es requerido" }}
        fullWidth
        disabled={isView}
      />
      <MTextField
        name="x2"
        label="X2"
        placeholder="X2"
        type="number"
        validation={{ required: "X2 es requerido" }}
        fullWidth
        disabled={isView}
      />
      <MTextField
        name="x3"
        label="X3"
        placeholder="X3"
        type="number"
        validation={{ required: "X3 es requerido" }}
        fullWidth
        disabled={isView}
      />
      <MTextField
        name="x4"
        label="X4"
        placeholder="X4"
        type="number"
        validation={{ required: "X4 es requerido" }}
        fullWidth
        disabled={isView}
      />
    </ResponsiveFormContainer>
  );
};

export default CentelleoForm;
